export enum ExportType {
  LOCAL = 'local',
  EMAIL = 'email'
}
